/**
 * MPH-945: departure-date flexibility for APEX result-page searches, expressed in days around the
 * searched departure date. The trip length never changes, only the departure date moves.
 *
 * Only ±1, ±3 and ±7 days are offered. Anything else in the URL — a typo, an old link, a probe —
 * falls back to fixed dates for every request, rather than being clamped to the nearest option.
 */
export const APEX_FLEXIBLE_DAYS_OPTIONS = [1, 3, 7] as const;

export type ApexFlexibleDaysOption = (typeof APEX_FLEXIBLE_DAYS_OPTIONS)[number];

/** Fixed ("Exact dates") — the default, and the fallback for any unsupported value. */
export const APEX_FLEXIBLE_DAYS_EXACT = 0;

export type ApexFlexibleDays = ApexFlexibleDaysOption | typeof APEX_FLEXIBLE_DAYS_EXACT;

export const isApexFlexibleDaysValue = (value: string | undefined): boolean =>
  APEX_FLEXIBLE_DAYS_OPTIONS.some((option) => `${option}` === value);

export const parseApexFlexibleDays = (value: string | undefined): ApexFlexibleDays =>
  isApexFlexibleDaysValue(value) ? (parseInt(value as string, 10) as ApexFlexibleDaysOption) : APEX_FLEXIBLE_DAYS_EXACT;
